import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrow-left.svg";
import { useTranslation } from "react-i18next";

function Index(props) {
  const { t } = useTranslation();
  return (
    <div className="pl-3 pr-3">
      <div className="404">
        <p className="color-primary" style={{ fontWeight: "600" }}>
          {t("404 error")}
        </p>
        <h1>{t("Page not found")}</h1>
        <p className="mb-4">
          {t(
            "Sorry, the page you are looking for doesn't exist. Here are some helpful links:"
          )}
        </p>
        <Link to={-1} className="btn btn-secondary btn-medium mr-1">
          <ArrowLeft />
          {t("Go back")}
        </Link>
        <Link to="/" className="btn btn-primary btn-medium">
          {t("Take me home")}
        </Link>
      </div>
    </div>
  );
}

export default Index;
